const KEY = 'korint:mfa-setup-skipped';

// Cleared on sign-out (UserSidebarFooter's useSignOut) so the next sign-in re-prompts.
export function skipMfaSetupForSession() {
  sessionStorage.setItem(KEY, '1');
}

export function isMfaSetupSkippedForSession(): boolean {
  return sessionStorage.getItem(KEY) === '1';
}

export function clearMfaSetupSkip() {
  sessionStorage.removeItem(KEY);
}
